import { render, staticRenderFns } from "./ClientDrive.vue?vue&type=template&id=5744830b&"
import script from "./ClientDrive.vue?vue&type=script&lang=ts&"
export * from "./ClientDrive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports